// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--cbbe8";
export var headingContainer = "index-module--heading-container--adaff";
export var highlight = "index-module--highlight--862f5";
export var highlightLine = "index-module--highlight-line--20d86";
export var image1 = "index-module--image-1--7cf7e";
export var image2 = "index-module--image-2--30431";
export var imageContainer = "index-module--image-container--7275c";